import styled from 'styled-components'

interface IBudgetCategoryTypeSelectStyledProps {}

export const BudgetCategoryTypeSelectStyled = styled.div<IBudgetCategoryTypeSelectStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
